import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  currentInvoiceEstimate: association('invoice-estimate'),
  nextInvoiceEstimate: association('invoice-estimate'),
  subscription: association('subscription'),

  app() {
    return faker.helpers.arrayElement(['deliveries', 'visitors']);
  },

  period() {
    return faker.helpers.arrayElement(['monthly', 'yearly']);
  },

  plan() {
    return faker.helpers.arrayElement(['standard', 'premium']);
  },

  quantity: faker.number.int(20),
  nextBillingAt: faker.date.future(),
});
